import React, { useState, Component } from 'react';
import { Calendar, Clock, Phone, MessageCircle, CheckCircle, ChevronRight } from 'lucide-react';
import { Button } from '../ui/Button';
const SERVICES = ['General Medical Consultations', 'Minor Surgical Procedures', 'Safe Medical Circumcision', 'Paternity Testing (DNA)', 'Immunizations', 'Pre-Employment Medical Examinations', 'Family Planning', 'Counseling Services', 'Chronic Disease Management', 'Physiotherapy', 'Optician Services', 'Antenatal Care', 'Postnatal Care', 'Laboratory Services', 'ECG Services', 'Ultrasound Services', 'Dentistry'];
const TIME_SLOTS = ['08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM'];
export function AppointmentSection() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    time: '',
    notes: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const update = (field: string, value: string) => setForm(prev => ({
    ...prev,
    [field]: value
  }));
  const isValid = form.name && form.phone && form.service && form.date;
  const whatsappLink = `https://wa.me/26773241613?text=${encodeURIComponent(`Hello Maisha Medical Center.\nI would like to book an appointment.\nName: ${form.name}\nPhone: ${form.phone}\nPreferred Service: ${form.service}\nPreferred Date: ${form.date}\nPreferred Time: ${form.time}\n\nPlease assist me.`)}`;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid) return;
    setSubmitted(true);
  };
  return <section className="relative py-24 overflow-hidden" data-id="element-59" data-mp="r5jnpdvh32kh">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/qbGmSXCEC9QH6TthgTKZco/maisha_edited_6.jpg" alt="Maisha Medical Center reception and waiting area" className="absolute inset-0 w-full h-full object-cover" data-id="element-60" data-mp="w3bcw04qgakz" />
      {/* Brand navy color overlay */}
      <div className="absolute inset-0 bg-brand-navy/90" data-id="element-61" data-mp="2wrxrsx7gfs8w" />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/85 to-brand-navy/70" data-id="element-62" data-mp="2srdw7y2j4wov" />

      <div className="relative z-10 max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63" data-mp="2o0fgazlge0m5">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-64" data-mp="2nycezjeuol24">
          {/* Intro copy */}
          <div className="w-full lg:w-1/2 text-white" data-id="element-65" data-mp="2e2hnrzwk9hnq">
            <span className="font-semibold tracking-wider text-sm uppercase mb-3 block text-[#FFFFFF]" data-id="element-66" data-mp="2e42lfye69gpt">
              Book Your Visit
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-67" data-mp="251b79qtww6uh">
              Request an Appointment Today
            </h2>
            <p className="text-slate-200 text-lg leading-relaxed mb-8 max-w-xl" data-id="element-68" data-mp="2052ycv6b59vr">
              Schedule your visit to Maisha Medical Center in just a few
              moments. Fill in your details and our reception team will confirm
              your appointment promptly.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-69" data-mp="5srzk6rwmw73">
              {['Trusted, experienced healthcare professionals', 'Comprehensive services under one roof', 'Fast confirmation via call or WhatsApp'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-70" data-mp="kj94i03r048q">
                  <CheckCircle className="w-6 h-6 text-brand-gold shrink-0" data-id="element-71" data-mp="3j27o20hgfndm" />
                  <span className="text-slate-100 font-medium" data-id="element-72" data-mp="3o0922700wwi8">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-6" data-id="element-73" data-mp="3syiy0jtko14w">
              <a href="tel:+2676540244" className="flex items-center gap-3 text-white group" data-id="element-74" data-mp="vji68ekyw6w">
                <span className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-brand-red transition-colors" data-id="element-75" data-mp="188l7ujce9i34">
                  <Phone className="w-5 h-5" data-id="element-76" data-mp="1att03x71brjc" />
                </span>
                <span data-id="element-77" data-mp="1au1ejtit34wn">
                  <span className="block text-xs text-slate-300" data-id="element-78" data-mp="1avm6rchnebrc">Call us</span>
                  <span className="font-semibold" data-id="element-79" data-mp="15wj1ps1o45jd">+267 6540244</span>
                </span>
              </a>
              <div className="flex items-center gap-3 text-white" data-id="element-80" data-mp="1kpw2931vzq6a">
                <span className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center" data-id="element-81" data-mp="1fs2y0fk5968n">
                  <Clock className="w-5 h-5 text-brand-gold" data-id="element-82" data-mp="1trc9x31bhe6t" />
                </span>
                <span data-id="element-83" data-mp="1osizjjhbu3av">
                  <span className="block text-xs text-slate-300" data-id="element-84" data-mp="1otahvslwy4j7">
                    Operating hours
                  </span>
                  <span className="font-semibold" data-id="element-85" data-mp="23kb4d1jhvyyc">Mon–Fri 8am–6pm</span>
                </span>
              </div>
            </div>
          </div>

          {/* Form card */}
          <div className="w-full lg:w-1/2" data-id="element-86" data-mp="2cjema26xe8b9">
            <div className="bg-white rounded-2xl shadow-soft-lg p-6 md:p-8" data-id="element-87" data-mp="28ht9egue5u12">
              {submitted ? <div className="text-center py-8" data-id="element-88" data-mp="2r5bvn8qcnfyr">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-89" data-mp="2r3r2nnjoo530">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-90" data-mp="2i55pk7wzdi9m" />
                  </div>
                  <h3 className="text-2xl font-heading font-bold text-brand-navy mb-3" data-id="element-91" data-mp="2i7i1o4g24yer">
                    Request Received!
                  </h3>
                  <p className="text-slate-600 mb-8" data-id="element-92" data-mp="28eazesgm5yiw">
                    Thank you, {form.name}. Our team will contact you shortly to
                    confirm your appointment for{' '}
                    <strong className="text-brand-navy" data-id="element-93" data-mp="1zfgywr05wo02">{form.service}</strong>.
                  </p>
                  <Button href={whatsappLink} target="_blank" variant="primary" fullWidth icon={<MessageCircle className="w-5 h-5" data-id="element-95" data-mp="1ufbcpqcnvtpd" />} className="bg-[#25D366] hover:bg-[#20bd5a] focus:ring-[#25D366]" data-id="element-94" data-mp="23fhjyuhrnxg3">
                    Confirm on WhatsApp
                  </Button>
                </div> : <>
                  <div className="flex items-center gap-3 mb-6" data-id="element-96" data-mp="3ncgf3yr69p2g">
                    <div className="w-11 h-11 rounded-xl bg-brand-red/10 flex items-center justify-center text-brand-red" data-id="element-97" data-mp="3ncop9ivwug9y">
                      <Calendar className="w-6 h-6" data-id="element-98" data-mp="iy8frhgere1e" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-brand-navy" data-id="element-99" data-mp="iw4e765zer4a">
                      Appointment Details
                    </h3>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-100" data-mp="9w8w0he0dvur">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-101" data-mp="4z8riawt515r">
                      <div data-id="element-102" data-mp="2unrh48lexzux">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-103" data-mp="2uo18o0m3wf2q">
                          Full Name *
                        </label>
                        <input required type="text" value={form.name} onChange={e => update('name', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" placeholder="John Doe" data-id="element-104" data-mp="2pr11tnhfn8ak" />
                      </div>
                      <div data-id="element-105" data-mp="33a2b0hvu2b61">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-106" data-mp="339apy0zv3vu0">
                          Phone Number *
                        </label>
                        <input required type="tel" value={form.phone} onChange={e => update('phone', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" placeholder="+267 ..." data-id="element-107" data-mp="3d8i0yhj4jedy" />
                      </div>
                    </div>

                    <div data-id="element-108" data-mp="3ugsso7lne6k5">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-109" data-mp="3uh13zv24h3t8">
                        Email Address
                      </label>
                      <input type="email" value={form.email} onChange={e => update('email', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" placeholder="john@example.com" data-id="element-110" data-mp="31sn8blyiajku" />
                    </div>

                    <div data-id="element-111" data-mp="m20zavllx816">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-112" data-mp="m2sit81xjfb3">
                        Preferred Service *
                      </label>
                      <select required value={form.service} onChange={e => update('service', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all bg-white text-slate-700" data-id="element-113" data-mp="tnwfgm96ji7e">
                        <option value="" disabled data-id="element-114" data-mp="1haustb206a13">
                          Select a service
                        </option>
                        {SERVICES.map(service => <option key={service} value={service} data-id="element-115" data-mp="12kdqlphjng35">
                            {service}
                          </option>)}
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-116" data-mp="201c7wctwx73z">
                      <div data-id="element-117" data-mp="203gl5ldpbigx">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-118" data-mp="1k0adlteirk9t">
                          Preferred Date *
                        </label>
                        <input required type="date" value={form.date} onChange={e => update('date', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all text-slate-700" data-id="element-119" data-mp="1o0aynww4itpu" />
                      </div>
                      <div data-id="element-120" data-mp="rdpn0v5vbc7b">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-121" data-mp="rabiphdn8sx8">
                          Preferred Time
                        </label>
                        <select value={form.time} onChange={e => update('time', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all bg-white text-slate-700" data-id="element-122" data-mp="hei9o7z4vhk7">
                          <option value="" data-id="element-123" data-mp="cq8rjhe3wza4">Any time</option>
                          {TIME_SLOTS.map(slot => <option key={slot} value={slot} data-id="element-124" data-mp="7orujwyqtwyt">
                              {slot}
                            </option>)}
                        </select>
                      </div>
                    </div>

                    <div data-id="element-125" data-mp="vfnr17e59gce">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-126" data-mp="vevwlzwa9onp">
                        Additional Notes
                      </label>
                      <textarea rows={2} value={form.notes} onChange={e => update('notes', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all resize-none" placeholder="Any specific concerns or symptoms?" data-id="element-127" data-mp="15e4n2irxwl5b" />
                    </div>

                    <Button type="submit" variant="primary" fullWidth disabled={!isValid} icon={<ChevronRight className="w-5 h-5" data-id="element-129" data-mp="1r8k0jw5rtey7" />} data-id="element-128" data-mp="1m74ga6bf3cgv">
                      Request Appointment
                    </Button>
                    <p className="text-xs text-slate-400 text-center" data-id="element-130" data-mp="207xeb10xgpoq">
                      Prefer the full booking experience?{' '}
                      <a href="/book" className="text-brand-red font-medium" data-id="element-131" data-mp="253w7d1x7avvh">
                        Book step-by-step
                      </a>
                    </p>
                  </form>
                </>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}